import {MithrilComponent} from '@bitstillery/mithril'
import {unique_id} from '@bitstillery/common/lib/utils'
import {modelref_adapter} from '@bitstillery/common/lib/store'
import m from '@bitstillery/mithril'

import type {ModelRef} from '@bitstillery/common/types/field'

interface RadioAttrs {
    id?: string
    name: string
    value: string
    label: string
    help?: string
    checked?: boolean
    onclick?: () => void
    model: ModelRef
}

export class FieldRadio extends MithrilComponent<RadioAttrs> {
    id = unique_id()

    view(vnode: m.Vnode<RadioAttrs>) {
        const {model_value} = modelref_adapter(vnode.attrs.model)
        return (
            <div className='c-field-radio field'>
                <div className='radio-control'>
                    <input
                        type='radio'
                        id={this.id}
                        name={vnode.attrs.name}
                        value={vnode.attrs.value}
                        checked={model_value === vnode.attrs.value}
                        onclick={vnode.attrs.onclick}
                    />
                    <label for={this.id}>{vnode.attrs.label}</label>
                </div>
                <div className='help'>{vnode.attrs.help}</div>
            </div>
        )
    }
}
